/* eslint-disable @typescript-eslint/no-explicit-any */
export const once = <Args extends any[], Ret, T extends (...args: Args) => Ret>(fn: T): T => {
    let called = false;
    let result: Ret;
    const newFn = (...args: Args) => {
        if (called) {
            return result;
        }
        called = true;
        result = fn(...args);
        return result;
    };
    return newFn as T;
};
